
import getObjectValue from "libs/getObjectValue";
import { Collapse } from "@material-ui/core";
import ContractDivided from "./ContractDivided";
import ContractNotDivided from "./ContractNotDivided";

function ContractData(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const hasMultipleObjects = gVal("form.noticeProcedureSummary.noticeObjectData.noticeHasManyObjects", false);
    console.log(hasMultipleObjects);
    return (
        <>
            <Collapse in={hasMultipleObjects === true}>
                <ContractDivided id={gId("divided[0]")} formikProps={formikProps} />
            </Collapse>
            <Collapse in={hasMultipleObjects === false}>
                <ContractNotDivided id={gId("notDivided")} formikProps={formikProps} />
            </Collapse>
        </>
    )
}

ContractData.propTypes = {};
export default ContractData;